import Vue from 'vue'
import Router from 'vue-router'

import home from '@/views/home/home'
import download from '@/views/download/download'

import share from '@/views/share/share'
import shareRoutes from '@/mixins/share'
const privacyPolicy = () => import('@/views/privacy-policy/privacy-policy')
const autorenewPolicy = () => import('@/views/autorenew-policy/autorenew-policy')
const notices = () => import('@/views/notices/notices')
const termsOfService = () => import('@/views/terms-of-service/terms-of-service')

const account = () => import('@/views/account/account')
const launch = () => import('@/views/launch/launch')
const overview = () => import('@/views/overview/overview')
const billing = () => import('@/views/billing/billing')
const privacy = () => import('@/views/privacy/privacy')
const redeem = () => import('@/views/redeem/redeem')
const redeemPortal = () => import('@/views/redeem/components/redeem-portal/redeem-portal')
const redeemCoupon = () => import('@/views/redeem/components/redeem-coupon/redeem-coupon')
const redeemDownload = () => import('@/views/redeem/components/redeem-download/redeem-download')
const downgraded = () => import('@/views/downgraded/downgraded')
const browsers = () => import('@/views/browsers/browsers')
const openApp = () => import('@/views/open-app/open-app')
const login = () => import('@/views/login/login')
const selfDelete = () => import('@/views/delete/delete')
const deleted = () => import('@/views/deleted/deleted')
const deletedFailed = () => import('@/components/deleted-failed/deleted-failed')
const deletedSuccess = () => import('@/components/deleted-success/deleted-success')
const itemShare = () => import('@/views/item-share/item-share')
const purchaseSuccess = () => import('@/views/purchase-success/purchase-success')
const staySafe = () => import('@/views/stay-safe/stay-safe')

const support = () => import('@/views/support/support')

// restricted
import upgraded from '@/views/upgraded/upgraded'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      name: 'home',
      component: home
    },
    {
      path: '/download',
      name: 'download',
      component: download
    },
    {
      path: '/pricing',
      name: 'pricing',
      redirect: { name: 'home' }
    },
    {
      path: '/try',
      name: 'try',
      redirect: { name: 'home' }
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/download/browsers',
      alias: '/download/browser',
      name: 'browsers',
      component: browsers
    },
    {
      path: '/support',
      name: 'support',
      component: support
    },
    {
      path: '/terms-of-service',
      name: 'terms-of-service',
      component: termsOfService
    },
    {
      path: '/autorenew-policy',
      name: 'autorenew-policy',
      component: autorenewPolicy
    },
    {
      path: '/privacy-notice',
      alias: '/privacy-policy',
      name: 'privacy-policy',
      component: privacyPolicy
    },
    {
      path: '/notices',
      name: 'notices',
      component: notices
    },
    {
      path: '/upgraded',
      name: 'upgraded',
      component: upgraded
    },
    {
      path: '/downgraded',
      name: 'downgraded',
      component: downgraded
    },
    {
      path: '/checkout',
      name: 'checkout',
      redirect: { name: 'home' }
    },
    {
      path: '/purchase-success',
      name: 'purchase-success',
      component: purchaseSuccess
    },
    {
      path: '/stay-safe',
      name: 'stay-safe',
      component: staySafe
    },
    // restricted views
    {
      path: '/account',
      component: account,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          name: 'overview',
          component: overview,
          meta: { requiresAuth: true,
            noScroll: true }
        },
        {
          path: 'update',
          name: 'update',
          component: overview,
          meta: { requiresAuth: true,
            noScroll: true }
        },
        {
          path: 'billing',
          name: 'billing',
          component: billing,
          meta: { requiresAuth: true,
            noScroll: true }
        },
        {
          path: 'privacy',
          name: 'privacy',
          component: privacy,
          meta: { requiresAuth: true,
            noScroll: true }
        },
        {
          path: '*',
          redirect: { name: 'overview' }
        }
      ]
    },
    {
      path: '/redeem',
      name: 'redeem',
      component: redeem,
      children: [
        {
          path: 'welcome',
          name: 'redeem-portal',
          component: redeemPortal
        },
        {
          path: 'coupon',
          name: 'redeem-coupon',
          component: redeemCoupon
        },
        {
          path: 'download',
          name: 'redeem-download',
          component: redeemDownload
        }
      ],
      beforeEnter: (to, from, next) => {
        if (to.path === '/redeem') {
          next({ replace: true, name: 'redeem-portal', query: to.query, hash: to.hash })
        } else {
          next()
        }
      }
    },
    {
      path: '/downgrade',
      name: 'downgrade',
      redirect: { name: 'home' }
    },
    {
      path: '/delete',
      name: 'delete',
      component: selfDelete
    },
    {
      path: '/upgrade',
      name: 'upgrade',
      redirect: { name: 'home' }
    },
    {
      path: '/deleted',
      component: deleted,
      children: [
        {
          path: '/',
          name: 'deleted-success',
          component: deletedSuccess
        },
        {
          path: 'failed',
          name: 'deleted-fail',
          component: deletedFailed
        }
      ]
    },
    {
      path: '/share',
      component: share,
      children: shareRoutes.routes
    },
    {
      path: '/launch',
      name: 'launch',
      component: launch
    },
    {
      path: '/item-share',
      name: 'item-share',
      component: itemShare
    },
    {
      path: '/open-app',
      name: 'open-app',
      component: openApp
    },
    {
      path: '/tos',
      redirect: '/terms-of-service'
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.meta.noScroll) return
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js